import { createQuery } from '@tanstack/svelte-query';
import { fetchZones } from '$lib/api/zone';
import type { ZoneResponse } from '$lib/types/zone';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const zonesQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<ZoneResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['zones', { unitId }],
			queryFn: async () => {
				const all = await fetchZones();
				return all.filter((z) => z.unit === unitId);
			},
			enabled: unitId > 0
		};
	});
